import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import { pushGtmValues } from "@bappweb/utils"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import SssList from "./ssslist"
import Notes from "./notes"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const getQueryStringValue = (paramName, defaultValue) => {
    const queryParams = new URLSearchParams(window.location.search)
    if (queryParams) {
        let retVal: any = queryParams.get(paramName)
        if (retVal) {
            return retVal
        }
        return defaultValue
    }
}

const Landing = () => {
    const [cid, setCid] = useState(() => getQueryStringValue("cid", ""))
    const [ts, setTs] = useState(() => getQueryStringValue("ts", ""))
    const [faqText, setFaqText] = useState<any[]>([]);

    const sessionData = useAppSelector((state) => state.sessionData.response)

    // GetConfig values
    useEffect(() => {
        if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, cid ? "KobiIsbirlikleri.Landing.Faq." + cid : "KobiIsbirlikleri.Landing.Faq"))) {
            setFaqText(JSON.parse(getConfigValue(sessionData?.configList, cid ? "KobiIsbirlikleri.Landing.Faq." + cid : "KobiIsbirlikleri.Landing.Faq")))
        }

        if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, "KobiIsbirlikleri.Landing.Seo.Faq"))) {
            const faqElement = document.createElement("script")
            faqElement.type = "application/ld+json"
            faqElement.textContent = getConfigValue(sessionData?.configList, "KobiIsbirlikleri.Landing.Seo.Faq")
            document.head.appendChild(faqElement)
        }
    }, [sessionData])

    //PushGTM values
    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "kobi-isbirlikleri",
            pageName: 'basvuru/kobi-isbirlikleri/0/landing',
            pageTitle: 'Kobi İşbirlikleri Başvurusu'
        })
    }, []);

    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader campaignHeaderText={getConfigValue(sessionData?.configList, !ts
                ? (cid
                    ? "KobiIsbirlikleri.CampaignText.Landing.Top." + cid
                    : "KobiIsbirlikleri.CampaignText.Landing.Top")
                : "KobiIsbirlikleri.MimCampaignText.Landing.Top")} cid={cid} />
            <Grid type="main" className="landing-page-main">
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1} className="landing-initialinfo-col">
                        <MainForm cid={cid} ts={ts} formTitle={getConfigValue(sessionData?.configList, cid ? "KobiIsbirlikleri.Landing.FormTitle." + cid : "KobiIsbirlikleri.Landing.FormTitle")} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <Notes campaignText={getConfigValue(sessionData?.configList, cid ? "KobiIsbirlikleri.CampaignText.Landing.Bottom." + cid : "KobiIsbirlikleri.CampaignText.Landing.Bottom")} campaignDetailText={getConfigValue(sessionData?.configList, cid ? "KobiIsbirlikleri.CampaignText.Landing.Bottom2." + cid : "KobiIsbirlikleri.CampaignText.Landing.Bottom2")} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <SssList faqText={faqText} />
                    </Col>
                </Row>
            </Grid>
        </Block>
    )
}

export default Landing
